import { headingTheme as e } from "./heading.mjs";
const a = {
  w: "full",
  bg: "surface",
  color: "onSurface.highEmphasis",
  display: "flex",
  flexDirection: "column",
  gap: 6,
  alignItems: "center",
  textStyle: "bodySm",
  py: 4,
  position: "relative"
}, r = {
  display: "flex",
  flexDirection: "column",
  gap: 2,
  alignItems: "center",
  w: "full"
}, c = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  w: "full"
};
var t, o;
const d = {
  ...e.baseStyle,
  ...(o = (t = e) == null ? void 0 : t.sizes) == null ? void 0 : o.xs,
  fontSize: "inherit",
  textAlign: "center",
  px: 4,
  hyphens: "manual"
}, p = {
  flexShrink: 0,
  boxSize: "6"
}, y = {
  px: 4,
  w: "full",
  display: "flex",
  justifyContent: "center",
  textAlign: "center",
  color: "onSurface.mediumEmphasis"
}, f = {
  px: 4,
  display: "flex",
  justifyContent: "center",
  w: "full"
}, u = {
  px: 4,
  w: "full",
  display: "flex",
  justifyContent: "center"
}, x = {
  right: 2,
  top: 2,
  position: "absolute",
  color: "onSurface.lowEmphasis"
}, b = {
  card: a,
  header: r,
  top: c,
  title: d,
  icon: p,
  description: y,
  body: f,
  footer: u,
  closeButton: x
};
var l, s, i, n;
const S = {
  s: {
    card: {
      textStyle: "bodySm"
    }
  },
  m: {
    card: {
      textStyle: "bodyMd"
    },
    header: {
      gap: 6
    },
    title: {
      ...(s = (l = e) == null ? void 0 : l.sizes) == null ? void 0 : s.lg
    }
  },
  l: {
    card: {
      textStyle: "bodyMd",
      py: 8
    },
    header: {
      gap: 6
    },
    title: {
      ...(n = (i = e) == null ? void 0 : i.sizes) == null ? void 0 : n.lg,
      px: 8
    },
    description: {
      px: 8
    },
    body: {
      px: 8
    },
    footer: {
      px: 8
    }
  }
}, g = {
  elevated: {
    card: {
      borderRadius: "lg",
      boxShadow: "e6",
      bg: "surface"
    }
  },
  outlined: {
    card: {
      borderRadius: "lg",
      border: "1px",
      borderColor: "onSurface.lowEmphasis",
      bg: "surface"
    }
  }
}, h = {
  variant: "outlined",
  size: "s"
}, w = {
  baseStyle: b,
  sizes: S,
  variants: g,
  defaultProps: h
};
export {
  w as odiCardTheme
};
